import React, { useRef } from 'react';

import { FlexColumn } from 'ui-components/components/flex';

import { CardFeed } from './components/engagement-section/card-feed';
import { OnboardCards } from './components/onboard-section/onboard-cards';
import { Sidebar } from './components/sidebar/sidebar';
import {
  COMPARE_RATES_VIDEO,
  CREATE_LABELS_VIDEO,
  SHIP_INTERNATIONALLY_VIDEO,
  AUTOMATION_VIDEO,
  BRANDED_TRACKING_VIDEO,
  CREATE_RETURN_LABELS_VIDEO,
  videoIds,
} from './constants';
import { HomePageOnboardContextProvider } from './home-page-onboard-context';
import style from './style.module.less';
import { useScript } from '../../hooks/use-script';
import { MigratePlanBanner } from '../settings/payment-and-subscription/components/migrate-plan-modal/migration-banner';

const WistiaScriptURL = '//fast.wistia.com/assets/external/E-v1.js';
const getVideoSrc = (videoId) => `//fast.wistia.com/embed/medias/${videoId}.jsonp`;

export const HomePage = () => {
  const wistiaRef = useRef();
  useScript(getVideoSrc(COMPARE_RATES_VIDEO), wistiaRef);
  useScript(getVideoSrc(CREATE_LABELS_VIDEO), wistiaRef);
  useScript(getVideoSrc(SHIP_INTERNATIONALLY_VIDEO), wistiaRef);
  useScript(getVideoSrc(AUTOMATION_VIDEO), wistiaRef);
  useScript(getVideoSrc(BRANDED_TRACKING_VIDEO), wistiaRef);
  useScript(getVideoSrc(CREATE_RETURN_LABELS_VIDEO), wistiaRef);

  useScript(WistiaScriptURL, wistiaRef);
  window._wq = window._wq || [];
  for (let i = 0; i < videoIds.length; i++) {
    window._wq.push({
      id: videoIds[i],
      onReady: (video) => video.bind(wistiaRef.current),
    });
  }

  return (
    <div ref={wistiaRef} className={style['home-page']}>
      <HomePageOnboardContextProvider>
        <OnboardCards />
      </HomePageOnboardContextProvider>
      <div className={style['cards-and-sidebar-container']}>
        <FlexColumn>
          <MigratePlanBanner className={style['promotional-banner']} />
          <div className={style['cards-and-sidebar']}>
            <CardFeed />
            <Sidebar />
          </div>
        </FlexColumn>
      </div>
    </div>
  );
};
